import Layout, { PageHeader } from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";
import { ShieldCheck, Buildings, User, Key } from "@phosphor-icons/react";

export default function Settings() {
  const { user } = useAuth();
  const Row = ({ icon: Icon, label, value }) => (
    <div className="flex items-center gap-4 py-4 border-b border-stone-100 last:border-0">
      <Icon size={20} className="text-[#C2410C]" />
      <div className="flex-1">
        <div className="text-xs uppercase tracking-wider text-stone-400">{label}</div>
        <div className="text-sm font-medium text-stone-900">{value}</div>
      </div>
    </div>
  );

  return (
    <Layout>
      <PageHeader title="Settings" subtitle="Organization & security" />
      <div className="p-8 max-w-2xl space-y-6">
        <div className="bg-white border border-stone-200 rounded-2xl shadow-card p-6">
          <h3 className="font-head font-semibold text-stone-950 mb-2">Account</h3>
          <Row icon={Buildings} label="Organization" value={user?.org_name} />
          <Row icon={User} label="Signed in as" value={`${user?.name} · ${user?.email}`} />
          <Row icon={ShieldCheck} label="Role" value={user?.role} />
          <Row icon={Key} label="Tenant ID" value={<span className="font-mono text-xs">{user?.tenant_id}</span>} />
        </div>
        <div className="bg-white border border-stone-200 rounded-2xl shadow-card p-6">
          <h3 className="font-head font-semibold text-stone-950 mb-3">Security</h3>
          <ul className="text-sm text-stone-600 space-y-2">
            <li className="flex items-center gap-2"><ShieldCheck size={16} className="text-emerald-600" /> Connector credentials encrypted at rest (Fernet/AES).</li>
            <li className="flex items-center gap-2"><ShieldCheck size={16} className="text-emerald-600" /> Strict tenant isolation enforced at the data layer.</li>
            <li className="flex items-center gap-2"><ShieldCheck size={16} className="text-emerald-600" /> Access tokens never exposed to the browser.</li>
            <li className="flex items-center gap-2"><ShieldCheck size={16} className="text-emerald-600" /> Full audit trail on all configuration & migration actions.</li>
          </ul>
        </div>
      </div>
    </Layout>
  );
}
